const ATTACHMENT_SERVE_ROUTE_RE =
  /^\/api\/(?:messaging\/web|public\/share\/[^/]+)\/attachments\/[^/]+\/serve\/?$/
const MESSAGING_ATTACHMENT_ROUTE_RE =
  /^\/api\/messaging\/web\/attachments\/([^/]+)\/serve\/?$/

function baseOrigin(): string {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin
  }
  return 'http://nex.local'
}

function toDisplayUrl(url: URL, original: string): string {
  const base = baseOrigin()
  if (original.startsWith('/') || url.origin === base) {
    return `${url.pathname}${url.search}${url.hash}`
  }
  return url.href
}

export function buildAttachmentDownloadUrl(
  fileUrl: string | null,
): string | undefined {
  if (!fileUrl) return undefined
  let parsed: URL
  try {
    parsed = new URL(fileUrl, baseOrigin())
  } catch {
    return fileUrl
  }
  if (
    !isAppRelativeOrSameOrigin(parsed, fileUrl) ||
    !ATTACHMENT_SERVE_ROUTE_RE.test(parsed.pathname)
  ) {
    return fileUrl
  }
  parsed.searchParams.set('disposition', 'attachment')
  return toDisplayUrl(parsed, fileUrl)
}

export function buildAttachmentPdfUrl(
  attachmentId: string,
  fileUrl: string | null,
): string | undefined {
  if (!fileUrl) return undefined
  let source: URL
  try {
    source = new URL(fileUrl, baseOrigin())
  } catch {
    return undefined
  }
  if (
    !isAppRelativeOrSameOrigin(source, fileUrl) ||
    !MESSAGING_ATTACHMENT_ROUTE_RE.test(source.pathname)
  ) {
    return undefined
  }
  const pdfUrl = new URL(
    `/api/messaging/web/attachments/${encodeURIComponent(attachmentId)}/pdf`,
    baseOrigin(),
  )
  const brandId = source.searchParams.get('brand_id')
  if (brandId) {
    pdfUrl.searchParams.set('brand_id', brandId)
  }
  return toDisplayUrl(pdfUrl, fileUrl)
}

function isAppRelativeOrSameOrigin(url: URL, original: string): boolean {
  return (
    (original.startsWith('/') && !original.startsWith('//')) ||
    url.origin === baseOrigin()
  )
}

export function pdfDownloadFilename(name: string): string {
  const cleanName = name.trim().split('/').pop() || 'artifact'
  const stem = cleanName.replace(/\.(html?|xhtml)$/i, '')
  return `${stem || 'artifact'}.pdf`
}
